<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer" @click="toggleView">
    <v-layout row wrap>
      <v-flex xs12 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap>
            <v-flex xs12 md8 text-xs-center text-sm-left>
              <v-layout row wrap body-1>
                <v-flex xs12 py-0 class="hidden-xs-only">
                  <span class="font-weight-light" v-if='isRfcPfWithoutCurp'>
                        RFC {{ mask('rfc_pf', record.rfc_pf) }}
                  </span>
                  <span class="font-weight-light" v-if='!isRfcPfWithoutCurp'>
                    {{ record.document_type.toUpperCase() }}
                    {{ mask(record.document_type, record.document_number) }}
                  </span>
                   - <span class="uppercase">{{record.social_name}}</span>
                </v-flex>
                <v-flex xs12 py-0 class="hidden-xs-only">
                  {{updated_time_label}} {{since_updated_time}}
                </v-flex>
                <v-flex xs12 py-0 class="hidden-sm-and-up">
                  {{record.document_type.toUpperCase()}}
                  {{mask(record.document_type, record.document_number)}}
                </v-flex>
                <v-flex xs12 py-0 class="hidden-sm-and-up">
                  <span class="uppercase">{{record.social_name}}</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex v-if="!showConfigForm" xs12 md4 py-0 text-md-right text-xs-center>
              <v-layout row wrap caption>
                <v-flex xs12 py-0>
                  Nível atual: {{record.clearance_level}}
                  <v-icon class="arrow-icon-small">arrow_forward</v-icon>
                  Nível necessário: {{record.required_clearance_level}}
                  <div class="company__source_info">{{source_info}}</div>
                </v-flex>
              </v-layout>
            </v-flex>

            <transition name="fade">
              <v-flex xs12 mt-3 v-if="current_view === 'detailed'" @click="stopUnlessUploading">
                <company-form admin subject operation="update" @onUpdate="onUpdate" @onReprove="onReprove" :record="record" v-if="isCompany" />
                <person-form admin subject operation="update" @onUpdate="onUpdate" @onReprove="onReprove" :record="record" v-if="isPerson" />
                <partner-form v-if="showConfigForm" :record="record" @onUpdatePartner="onUpdatePartner" />
              </v-flex>
            </transition>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
  </v-flex>
</template>
<script>
import utils from "./shared/Utils"
import AdminPartnerConfigForm from "./AdminPartnerConfigForm.vue"
import AdminCompanyForm from "./AdminCompanyForm"
import AdminPersonForm from "./AdminPersonForm"

export default {
  name: 'SubjectItem',
  components: {
    'partner-form': AdminPartnerConfigForm,
    'company-form': AdminCompanyForm,
    'person-form': AdminPersonForm
    },
  props: {
    record: {
      type: Object
    },
    showConfigForm: {
      type: Boolean,
      default: false
    },
    admin: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      current_view: 'short',
    }
  },
  computed: {
    url() {
      return this.$root.urls.admin_companies
    },
    updated_time_label() {
      if (this.record.status == 'reproved') return 'Reprovado há'
      if (this.record.status == 'approved') return 'Aprovado há'
      return 'Aguardando há'
    },
    since_updated_time() {
      if (this.record.status == 'reproved' || this.record.status == 'approved') {
        return this.sinceDbDateTimeToHuman(this.record.updated_at)
      }
      return this.sinceDbBusinessDateTimeToHuman(this.record.updated_at)
    },
    isPerson() {
      return utils.isPerson(this.record) && !this.showConfigForm
    },
    isCompany() {
      return utils.isCompany(this.record) && !this.showConfigForm
    },
    isRfcPfWithoutCurp() {
      return utils.isRfcPfWithoutCurp(this.record)
    },
    source_info() {
      if (!this.admin) return ''

      if (this.record.subject_owners && this.record.subject_owners[0]) {
        const first_owner = this.record.subject_owners[0]
        if (first_owner.company) {
          return `via ${first_owner.company.company_name} (${first_owner.username})`
        } else {
          return `via ${first_owner.username}`
        }
      } else {
        if (this.record.users[0]) {
          return `via Portal (${this.record.users[0].username})`
        } else {
          return 'via Portal'
        }
      }
    }
  },
  methods: {
    stopUnlessUploading(e) {
      if (e.target.type === 'file') {
        return true
      } else {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },
    toggleView(e) {
      if (e.target.type !== 'file') {
        this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'
        e.preventDefault()
      }
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    mask(format, value) {
      return utils.mask(format, value)
    },
    dbDateTimeToHuman(value) {
      return utils.dbDateTimeToHuman(value)
    },
    sinceDbDateTimeToHuman(value) {
      return utils.sinceDbDateTimeToHuman(value)
    },
    sinceDbBusinessDateTimeToHuman(value) {
      return utils.sinceDbBusinessDateTimeToHuman(value)
    },
    onUpdatePartner(updatedRecord) {
      this.$emit('onUpdatePartner', updatedRecord)
    },
    onUpdate() {
      this.$emit('onUpdate', this.record)
      this.current_view = 'short'
    },
    onReprove() {
      this.$emit('onReprove', this.record)
      this.current_view = 'short'
    },
    onCancel() {
      this.current_view = 'short'
    }
  },
  mounted() {
    this.record = utils.letShowEmptyCurpIfRequired(this.record);
  }
}
</script>
<style>
  .company__source_info {
    color: var(--silver-color-font-color);
  }
</style>



// WEBPACK FOOTER //
// src/SubjectItem.vue